import { categories } from '@/mocks/categories';
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div
        className="absolute inset-0 z-0"
        style={{
          background: 'linear-gradient(135deg, oklch(0.96 0.015 88) 0%, oklch(0.93 0.03 82) 40%, oklch(0.94 0.025 95) 70%, oklch(0.955 0.012 90) 100%)',
        }}
      />

      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-4 md:px-6 pt-24 pb-16 md:pb-24 flex flex-col lg:flex-row items-start gap-12 lg:gap-20">
        <div className="w-full lg:w-3/5">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-white/80 backdrop-blur-sm rounded-full border border-background-200/50 mb-8">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-medium text-foreground-600 tracking-wide whitespace-nowrap">Curated Fashion Spreadsheet</span>
          </div>

          <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-extrabold text-foreground-950 leading-[1.05] tracking-tight">
            Pandabuy
            <br />
            Spreadsheet
            <br />
            <span className="italic font-normal text-foreground-700">2026</span>
          </h1>

          <p className="mt-8 text-lg md:text-xl text-foreground-600 leading-relaxed max-w-xl">
            The ultimate curated <strong>pandabuyspreadsheet</strong> with thousands of fashion finds, streetwear gems, and budget luxuries — updated weekly for smart shoppers worldwide.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-800 text-white rounded-full text-sm font-semibold hover:bg-primary-900 transition-all cursor-pointer whitespace-nowrap"
            >
              pandabuy sheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 text-sm font-semibold text-foreground-800 border-b-2 border-foreground-800 hover:text-accent-500 hover:border-accent-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              buy it now
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <div className="w-full lg:w-2/5">
          <p className="text-base text-foreground-500 leading-relaxed mb-8 max-w-sm">
            Discover the most updated <strong>pandabuyspreadsheet</strong> with thousands of curated fashion items, sneakers, streetwear, and hidden budget gems updated weekly.
          </p>

          <div className="rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20flat%20lay%20of%20minimalist%20fashion%20items%20including%20sneakers%20and%20accessories%20on%20cream%20textured%20surface%2C%20desaturated%20monochrome%20aesthetic%20with%20soft%20shadows%2C%20editorial%20product%20photography%2C%20clean%20composition%20with%20negative%20space%2C%20warm%20neutral%20color%20palette%2C%20high%20end%20minimal%20layout&width=1200&height=800&seq=hero-fashion-flatlay-01&orientation=landscape"
              alt="Curated fashion finds flat lay - pandabuyspreadsheet"
              title="PandabuySpreadsheet Fashion Collection"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}